import { NgIf, NgStyle, NgTemplateOutlet } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  HostBinding,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  signal
} from '@angular/core';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { ThemeAssetComponent } from '@partners/themes';
import { PanelBodyDirective, PanelTitleDirective } from './panel-slots';

@Component({
  selector: 'expansion-panel',
  standalone: true,
  imports: [NgIf, NgStyle, NgTemplateOutlet, MatExpansionModule, ThemeAssetComponent],
  template: `
    <mat-expansion-panel [hideToggle]="!hasToggle" #panel [expanded]="false">
      <mat-expansion-panel-header>
        <ng-container *ngIf="panelTitle?.tpl">
          <mat-panel-title>
            <ng-container *ngTemplateOutlet="panelTitle.tpl"></ng-container>
          </mat-panel-title>
        </ng-container>
      </mat-expansion-panel-header>

      <ng-container *ngIf="panelBody?.tpl">
        <ng-container *ngTemplateOutlet="panelBody.tpl"></ng-container>
      </ng-container>
    </mat-expansion-panel>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'expansion-panel'
  }
})
export class ExpansionPanelComponent implements OnInit, AfterViewInit {
  @ViewChild('panel', { static: true, read: MatExpansionPanel })
  panel: MatExpansionPanel;

  @ContentChild(PanelTitleDirective, { static: true })
  panelTitle: PanelTitleDirective;

  @ContentChild(PanelBodyDirective, { static: true })
  panelBody: PanelBodyDirective;

  isReady$$ = signal<boolean>(false);

  @Input()
  headerMode: 'stretched' | 'auto' = 'auto';

  @HostBinding('class')
  get headerClass() {
    if (this.headerMode === 'stretched') {
      return 'stretched-header';
    }
    return 'auto-header';
  }

  get isOpen(): boolean {
    return this.panel.expanded;
  }

  @Input()
  hasToggle: boolean = true;

  ngOnInit(): void {
    this.panel.close();
  }

  ngAfterViewInit(): void {
    this.panel.close();
    this.isReady$$.set(true);
  }

  toggle() {
    this.isOpen ? this.panel.open() : this.panel.close();
  }

  open() {
    this.panel.open();
  }
  close() {
    this.panel.close();
  }
}
